<template>
  <page>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <message :messages="messages"></message>
          <form>
            <v-flex xs12>
              <v-expansion-panels v-model="panel1" multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div>
                      <v-icon>mdi-filter-variant</v-icon> Date Range
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-sm>
                          <v-layout row wrap>
                            <v-flex xs6 md6>
                              <cal-picker v-model="form.pdPTranDateFrm" :label="labels.pdPTranDateFrm" v-validate="doValidatePdPTranDateFrom" :data-vv-as="labels.pdPTranDateFrm" data-vv-name="pdPTranDateFrm" :error-messages="errors.collect('pdPTranDateFrm')"></cal-picker>
                            </v-flex>
                            <v-flex xs6 md6>
                              <cal-picker v-model="form.pdPTranDateTo" :label="labels.pdPTranDateTo" v-validate="doValidatePdPTranDateTo" :data-vv-as="labels.pdPTranDateTo" data-vv-name="pdPTranDateTo" :error-messages="errors.collect('pdPTranDateTo')" :min="this.form.pdPTranDateFrm"></cal-picker>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap>
                            <v-flex xs6 md6>
                              <cal-picker v-model="form.pdCTranDateFrm" :label="labels.pdCTranDateFrm" v-validate="doValidatePdCTranDateFrom" :data-vv-as="labels.pdCTranDateFrm" data-vv-name="pdCTranDateFrm" :error-messages="errors.collect('pdCTranDateFrm')"></cal-picker>
                            </v-flex>
                            <v-flex xs6 md6>
                              <cal-picker v-model="form.pdCTranDateTo" :label="labels.pdCTranDateTo" v-validate="doValidatePdCTranDateTo" :data-vv-as="labels.pdCTranDateTo" data-vv-name="pdCTranDateTo" :error-messages="errors.collect('pdCTranDateTo')" :min="this.form.pdCTranDateFrm"></cal-picker>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-flex>
            <v-flex xs12>
              <v-checkbox v-model="form.pbPrtParam" :label="labels.pbPrtParam" :error-messages="errors.collect('pbPrtParam')" data-vv-name="pbPrtParam" :data-vv-as="labels.pbPrtParam" v-validate="'required'"></v-checkbox>
              <v-btn class="mr-2 mb-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
                <v-icon left dark>mdi-file-export</v-icon>
                {{labels.export}}
              </v-btn>
              <v-btn-toggle dense mandatory v-model="form.format">
                <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                  <span>{{format.label}}</span>
                  <v-icon :color="format.color">{{format.icon}}</v-icon>
                </v-btn>
              </v-btn-toggle>
            </v-flex>
          </form>
        </v-flex>
      </v-layout>
    </v-container>
  </page>
</template>

<script>
import { reportFormat } from '@/const/report'
import { extractMenu } from '@/utils/extract'
import MessageMixin from '@/mixins/message'
import isAfter from 'date-fns/isAfter'
import { removeTime } from '@/utils/date'

export default {
  data() {
    return {
      labels: {
        pdPTranDateFrm: 'Previous Period Transaction Date From*',
        pdPTranDateTo: 'Previous Period Transaction Date To*',
        pdCTranDateFrm: 'Current Period Transaction Date From*',
        pdCTranDateTo: 'Current Period Transaction Date To*',
        pbPrtParam: 'Print Runtime Parameters',
        export: 'EXPORT TO',
        sendEmail: 'Send Output to Email'
      },
      form: {
        pdPTranDateFrm: '',
        pdPTranDateTo: '',
        pdCTranDateFrm: '',
        pdCTranDateTo: '',
        pbPrtParam: true,
        format: 'PDF',
        sendEmail: false
      },
      menu: {},
      supportedFormat: [],
      submitting: false,
      panel1: [0],
      panel2: [0]
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.claimReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    doValidatePdPTranDateFrom() {
      const today = new Date()
      return 'required|valMaxDate:' + today
    },
    doValidatePdPTranDateTo() {
      if (this.form.pdPTranDateFrm !== null) {
        return 'required|valMinDate:' + this.form.pdPTranDateFrm
      } else {
        return 'required'
      }
    },
    doValidatePdCTranDateFrom() {
      const today = new Date()
      return 'required|valMaxDate:' + today
    },
    doValidatePdCTranDateTo() {
      if (this.form.pdCTranDateFrm !== null) {
        return 'required|valMinDate:' + this.form.pdCTranDateFrm
      } else {
        return 'required'
      }
    }
  },
  created() {
    this.$validator.extend('valMaxDate', {
      getMessage(field, args) {
        return 'Cannot be later than System Date'
      },
      validate(value, args) {
        let maxDate = args[0]
        if (value) {
          return !isAfter(removeTime(value), removeTime(maxDate))
        } else return true
      }
    })
    this.$validator.extend('valMinDate', {
      getMessage(field, args) {
        return 'Cannot be earlier than From Date'
      },
      validate(value, args) {
        let mixDate = args[0]
        if (value) {
          return !isAfter(removeTime(mixDate), removeTime(value))
        } else return true
      }
    })
  },
  watch: {
    'supportedList': function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.form.format = value[0].value
      }
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.claimReports.init !== 1) {
          await this.$store.dispatch('claimReportsInit')
        }
        const apiURI = this.rptMenu.clmRIAdjChklist
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result
          if (data) {
            this.supportedFormat = data.data.format
            this.menu = extractMenu(result.data._links)
          }
        }
        this.doneInitialization = true
      } catch (err) {
        throw err
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.form)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  mounted() {
    this.doInit()
  },
  mixins: [
    MessageMixin
  ]
}
</script>
